import { createSelector } from 'reselect';
import ParcelTemplate from '~/types/ParcelTemplate';
import { ApplicationState } from '../store';

export const getPackagesStore = (state: ApplicationState) => state.packages;

export const getDefaultWeightUnit = createSelector(
  getPackagesStore,
  (packagesStore): string => packagesStore.defaultWeightUnit,
);

export const getDefaultDistanceUnit = createSelector(
  getPackagesStore,
  (packagesStore): string => packagesStore.defaultDistanceUnit,
);

export const getActiveParcelTemplate = createSelector(
  getPackagesStore,
  (packageStore): Maybe<ParcelTemplate> => packageStore.parcelTemplate,
);
